import { Check } from "lucide-react"
import type { ReactNode } from "react"
import { ToastContext, useToastProvider } from "../hooks/useToast"

export function ToastProvider({ children }: { children: ReactNode }) {
	const ctx = useToastProvider()

	return (
		<ToastContext value={ctx}>
			{children}
			<ToastOverlay toasts={ctx.toasts} />
		</ToastContext>
	)
}

function ToastOverlay({
	toasts,
}: {
	toasts: { id: number; message: string }[]
}) {
	if (toasts.length === 0) return null

	return (
		<div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[100] flex flex-col-reverse gap-2 pointer-events-none">
			{toasts.map((t) => (
				<div
					className="rounded-xl px-4 py-2.5 flex items-center gap-2 shadow-lg border border-subtle animate-[toast-in_150ms_ease-out]"
					style={{ backgroundColor: "#1e1e22" }}
					key={t.id}
				>
					<Check className="w-3.5 h-3.5 text-green-400 shrink-0" />
					<span className="font-mono text-sm text-neutral-400">
						{t.message}
					</span>
				</div>
			))}
		</div>
	)
}
